import clients from './clients.json';

const active = clients.clients[clients.active];

window.firebase.initializeApp(active.firebaseConfig);

console.log("🔥 Firebase initialized:", active.firebaseConfig.projectId);

export const config = {
  ...active,
  mapsKey: clients.shared.mapsKey,
};